import styled from "styled-components"
import { themeGet } from "styled-system"
export const WaysToUseMailroomStaticsMainWrapper = styled.section`
  background-color: ${props =>
    props.backgroundColor
      ? props.backgroundColor
      : themeGet("colors.light", "#FFFFFF")};
  width: 100%;
  height: auto;
  ${({ theme }) => theme.se`
   margin-bottom: 2rem;
   
  `}

  ${({ theme }) => theme.desktop`
    margin-bottom: 3rem;

  `}
`
export const WaysToUseMailroomStaticsWrapper = styled.section`
  background-color: #FFFFFF;
  width: 100%;
  height: auto;
  margin-left:auto;
margin-right: auto;
border-radius: 10px;
display: flex;
  ${({ theme }) => theme.se`
  flex-direction:column;
  width: 100%;
  max-width: 300px;
  `}
  ${({ theme }) => theme.phone`
  width: 100%;
  max-width: 350px;
  `}
  ${({ theme }) => theme.phablet`
  width: 100%;
  max-width: 550px;
  `}
  ${({ theme }) => theme.tablet`
  flex-direction:row;
  width: 100%;
  max-width: 650px;
  `}
  ${({ theme }) => theme.desktop`
  width: 100%;
  max-width: 860px;
  `}
  ${({ theme }) => theme.largeDesktop`
  width: 100%;
  max-width: 1000px;
  `}
  ${({ theme }) => theme.massiveDesktop`
  width: 100%;
  max-width: 1173px;
  `}
`

export const WaysToUseMailroomStaticsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap:wrap;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  ${({ theme }) => theme.se`
  max-width: 250px;
  margin-top:2rem;
   `}
    ${({ theme }) => theme.phone`
  max-width: 300px;
    `}
 
   ${({ theme }) => theme.phablet`
  max-width: 400px;
  margin-top:3rem;
     `}
 
   ${({ theme }) => theme.tablet`
   align-self:center;
   max-width: 600px;
  height:140px;
   `}
 
   ${({ theme }) => theme.desktop`
  max-width: 750px;
  height:200px;
   `}
 
   ${({ theme }) => theme.largeDesktop`
  max-width: 870px;
      `}
   ${({ theme }) => theme.massiveDesktop`
  max-width: 1140px;
      `}
  .WaysToUseMailroomStatics-text {
    color:#232F57;
    font-family: 'Muli';
    ${({ theme }) => theme.se`
    font-size: 11px;
    line-height: 20px;
    letter-spacing: 0.3px;
   
  `}
   ${({ theme }) => theme.phone`
   font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.3px;
      
   `}

  ${({ theme }) => theme.phablet`
  font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.3px;
      
    `}

  ${({ theme }) => theme.tablet`
  font-size: 12px;
    line-height: 22px;
    letter-spacing: 0.4px;
    
  `}

  ${({ theme }) => theme.desktop`
  font-size: 15px;
    line-height: 22px;
    letter-spacing: 0.4px;
  `}

  ${({ theme }) => theme.largeDesktop`
  font-size: 18px;
    line-height: 26px;
    letter-spacing: 0.5px;
     `}
  ${({ theme }) => theme.massiveDesktop`
  font-size: 16px;
    line-height: 25px;
    letter-spacing: 0.5px;
     `}
  }
  .WaysToUseMailroomStatics-image {
    ${({ theme }) => theme.se`
    width:50px;
   
  `}
   ${({ theme }) => theme.phone`
    width:60px;
      
   `}

  ${({ theme }) => theme.phablet`
    width:60px;
      
    `}

  ${({ theme }) => theme.tablet`
    width:60px;

    
  `}

  ${({ theme }) => theme.desktop`
    width:70px;

  `}

  ${({ theme }) => theme.largeDesktop`
    width:76px;

     `}
  ${({ theme }) => theme.massiveDesktop`
    width:86px;

     `}
  }
`

export const WaysToUseMailroomStaticsDescriptionInnerContainer = styled.div`
display: flex;
flex-direction: column;
text-align: center;
align-items: center;
width:100%;
  ${({ theme }) => theme.largeDesktop`
    max-width:80%
     `}
     .heading {
      width: 100%;
    max-width: 965px;
    margin-left: auto;
    margin-right: auto;
    text-align:left;
  color: #242f57;
  letter-spacing: 0.63px;
  font-weight: 900;
    font-family: 'Muli';
      ${({ theme }) => theme.se`
    font-size: 11px;
   padding-top: 2em;
  line-height: 25px;
  max-width: 250px;
width: 100%;   
margin-bottom: 5px;
  `}
  ${({ theme }) => theme.phone`
   
max-width: 300px;
width: 100%;  
   font-size: 13px;
   padding-top: 2em;
  line-height: 25px;

  `}
  ${({ theme }) => theme.phablet`
  font-size: 18px;
  padding-top: 3em;
  line-height: 30px;
max-width: 500px;
width: 100%;   
margin-bottom: 15px;

  `}
  ${({ theme }) => theme.tablet`
  font-size: 18px;
  padding-top: 3em;
  line-height: 15px;
  max-width: 600px;
width: 100%;  
  `}
  ${({ theme }) => theme.desktop`
  font-size: 20px;
  padding-top: 3em;
  line-height: 15px;
  max-width: 750px;
width: 100%;   
margin-bottom: 1.45rem;
  `}
  ${({ theme }) => theme.largeDesktop`
  font-size: 30px;
  padding-top: 3em;
  line-height: 30px;
  max-width: 865px;
width: 100%; 
  `}
  ${({ theme }) => theme.massiveDesktop`
  font-size: 32px;
  padding-top: 2em;
  line-height: 30px;
  max-width: 965px;
width: 100%; 
  `}
     }
     .description{
      text-align: left;
font-weight: 600;
font-family: 'Muli';
line-height: 32px;
font-size: 20px;
letter-spacing: 0.55px;
max-width: 965px;
width: 100%;
margin-left: auto;
margin-right: auto;
color: #5D6C97;
${({ theme }) => theme.se`
line-height: 18px;
font-size: 9px;
letter-spacing: 0.35px;
max-width: 250px;
width: 100%;   
  `}
  ${({ theme }) => theme.phone`
line-height: 20px;
font-size: 11px;
letter-spacing: 0.35px;
max-width: 300px;
width: 100%;   
  `}
  ${({ theme }) => theme.phablet`
line-height: 20px;
font-size: 11px;
letter-spacing: 0.55px;
max-width: 500px;
width: 100%;   
  `}
  ${({ theme }) => theme.tablet`
line-height: 24px;
font-size: 12px;
letter-spacing: 0.45px;
max-width: 600px;
width: 100%;   
  `}
  ${({ theme }) => theme.desktop`
line-height: 25px;
font-size: 14px;
letter-spacing: 0.6px;
max-width: 750px;
width: 100%;   
  `}
  ${({ theme }) => theme.largeDesktop`
line-height: 26px;
font-size: 15px;
letter-spacing: 0.45px;
max-width: 865px;
width: 100%;   
  `}
  ${({ theme }) => theme.massiveDesktop`
line-height: 30px;
font-size: 18px;
letter-spacing: 0.5px;
max-width: 965px;
width: 100%;   
  `}
     }
`
